export const MARKER_GENE_SUFFIX_IDENTIFIER = " - marker genes";
export const MINI_HISTOGRAM_WIDTH = 110;
